export const faqItemToggleVariants = [
  { d: 'M1 9 L17 9' },
  {
    d: 'M9.2 1 L9.2 17',
    variants: { closed: { opacity: 1 }, open: { opacity: 0 } },
    transition: { duration: 0.3 },
  },
];
